import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
  WritableSignal
} from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {
  IonButton, IonButtons, IonCol,
  IonContent, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonMenuToggle, IonRow, IonSkeletonText, IonSpinner,
} from "@ionic/angular/standalone";
import {PropertyCardComponent} from "../common/property-card/property-card.component";
import {FooterComponent} from "../../common/footer/footer.component";
import {PropertyService} from "../property.service";
import { FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CurrencyPipe} from "@angular/common";
import {ActivatedRoute} from "@angular/router";
// Google Maps removed - not used (page redirects to external URL)
import {FilterService} from "../../common/filter/filter.service";
import {PipesModule} from "../../common/filter/pipes/pipes.module";
import {environment} from "../../../environments/environment";
import {CustomSortPipe} from '../../core/custom-sort.pipe';
import {ListingFilterComponent} from './listing-filter/listing-filter.component';
import {PropertyFilterPipe} from '../../common/filter/pipes/property-filter.pipe';
import {CurrencyConvertService} from '../../core/currency.convert.service';
import {Meta, Title} from '@angular/platform-browser';
import {TranslateModule} from '@ngx-translate/core';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-listing-page',
    templateUrl: './listing-page.component.html',
    styleUrls: ['./listing-page.component.scss'],
    standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    IonContent,
    HeaderComponent,
    PropertyCardComponent,
    FooterComponent,
    IonButton,
    ReactiveFormsModule,
    FormsModule,
    PipesModule,
    CustomSortPipe,
    ListingFilterComponent,
    PropertyFilterPipe,
    IonInfiniteScroll,
    IonSpinner,
  ],
    providers: [CurrencyPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ListingPageComponent implements OnInit {
  @ViewChild('scrollContainer', { static: true}) private scrollContainer!: ElementRef;
  isScrolled: boolean = false;
  propertyService: PropertyService = inject(PropertyService);
  filterService: FilterService = inject(FilterService);
  route: ActivatedRoute = inject(ActivatedRoute);
  properties: any = [];
  propertiesMap: any = [];
  resultsLength: number = 0;
  subCategoryId: WritableSignal<string> = signal('');
  isLoading: WritableSignal<boolean> = signal(true);

  currencyPipe: CurrencyPipe = inject(CurrencyPipe);
  param: any;
  title: Title = inject(Title);
  meta: Meta = inject(Meta);
  constructor() {
    // Google Maps removed - page redirects to external URL
  }


  async ngOnInit() {
    const externalUrl = `https://listings.satel.sa`;
    window.location.href = externalUrl;
    
    this.title.setTitle('Rent Villas, Apartments & More | Property Listings in Riyadh');

    this.meta.addTags([
      {property: 'og:title', content: 'Rent Villas, Apartments & More | Property Listings in Riyadh'},
      {name: 'description', content: 'Browse our extensive selection of properties for rent in Riyadh, including villas, apartments, and compounds. Find your perfect home today!'},
      {property: 'og:description', content: 'Browse our extensive selection of properties for rent in Riyadh, including villas, apartments, and compounds. Find your perfect home today!'},
      {property: 'og:image', content: 'https://satel-resources.nyc3.digitaloceanspaces.com/02bcebe5-a07e-473a-a6bc-054e254d4ce8.jpg'},
      {property: 'og:site_name', content: 'satel.sa'},
      {property: 'og:url', content: `https://satel.sa/`},
      {property: 'og:type', content: 'article'},
      {name: 'twitter:site', content: 'satel.sa'},
      {name: 'twitter:title', content: 'Rent Villas, Apartments & More | Property Listings in Riyadh'},
      {name: 'twitter:description', content: 'Browse our extensive selection of properties for rent in Riyadh, including villas, apartments, and compounds. Find your perfect home today!'},
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:image', content: 'https://satel-resources.nyc3.digitaloceanspaces.com/02bcebe5-a07e-473a-a6bc-054e254d4ce8.jpg'}
    ]);
    this.route.queryParams.subscribe(async (param: any) => {
      this.param = param;
      this.filterService.filterData.set(param);
      if (param.sub) {
        this.subCategoryId.set(param.sub);
        const properties = await this.propertyService.getProperties({ subCatId: param.sub, limit: 10, ver: 2 });
        this.propertiesMap = await this.propertyService.getProperties({ subCatId: param.sub, map: true });
        this.properties = properties.data;
        this.resultsLength = properties.totalCount;
      } else {
        const newParam = {...param, limit: 10, ver: 2};
        const properties = await this.propertyService.getProperties({ ...newParam });
        this.propertiesMap = await this.propertyService.getProperties({ ...param, map: true});
        this.properties = properties.data;
        this.resultsLength = properties.totalCount;
      }
      this.isLoading.set(false);
    });
  }
  filteredId: string = '';
  currencyConvertService: CurrencyConvertService = inject(CurrencyConvertService);
  filterQuery: string = '';
  onScroll($event: any) {
    this.isScrolled = $event.detail.scrollTop > 50;
  }
  scrollToTop(): void {
    this.scrollContainer.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  async filterValueChanged($event: any) {
    this.filterQuery = $event;
    console.clear();
    console.log($event);
    const properties = await this.propertyService.getProperties({ propertyNumber: $event });
    console.log(properties);
    this.properties = properties;

  }
  allPropertiesLoaded = false;
  isLoadingMore = signal(false);
  loadMoreManually() {
    const lastId = this.properties[this.properties.length - 1]?._id;
    this.getMoreProperties(lastId);
  }

  async getMoreProperties(lastId: string, missingId?: string) {
    let param = this.param;
    this.isLoadingMore.set(true);
    if (lastId) {
      param = {...param, limit: 10, lastId: lastId};
    } else {
      param = {...param, missingId};
    }
    const moreProperties = await this.propertyService.getProperties({ ...param });
    console.log(moreProperties);
    for (const prop of moreProperties) {
      if (lastId) {
        this.properties.push(prop);
      } else {
        this.properties.unshift(prop);
      }
    }
    this.isLoadingMore.set(false);
    if (missingId) {
      setTimeout(() => {
        this.scrollToTop();
      }, 500);
    }
  }
  onIonInfinite($event: any, lastId: string) {
    console.log($event, lastId, this.properties[this.properties.length - 1]._id);
    this.getMoreProperties(lastId);
    setTimeout(() => {
      $event.target.complete();
    }, 500);
  }

}
